export const THEME_STORAGE_KEY = 'theme';

export type ThemePreference = 'dark' | 'light' | 'system';
export type ResolvedTheme = 'dark' | 'light';

const VALID_THEMES: ThemePreference[] = ['dark', 'light', 'system'];

export function isThemePreference(value: string | null): value is ThemePreference {
	return value !== null && VALID_THEMES.includes(value as ThemePreference);
}

export function getStoredTheme(getItem: (key: string) => string | null): ThemePreference {
	const storedTheme = getItem(THEME_STORAGE_KEY);
	return isThemePreference(storedTheme) ? storedTheme : 'dark';
}

export function resolveTheme(theme: ThemePreference, prefersDark: boolean): ResolvedTheme {
	if (theme === 'system') {
		return prefersDark ? 'dark' : 'light';
	}

	return theme;
}

export function applyTheme(
	root: { setAttribute: (name: string, value: string) => void },
	theme: ThemePreference,
	prefersDark: boolean
): ResolvedTheme {
	const resolvedTheme = resolveTheme(theme, prefersDark);
	root.setAttribute('data-theme', resolvedTheme);
	root.setAttribute('data-theme-preference', theme);
	return resolvedTheme;
}
